

































import Vue from 'vue'
import QcqCommonGrid from '@/components/QcqCommonGrid.vue'
import { Competence } from '@/model/qcq/Competence'
import {
  LOAD_COMPETENCE, LOAD_COMPETENCE_ROW, INSERT_COMPETENCE,
  UPDATE_COMPETENCE, DELETE_COMPETENCE
} from '@/store/action-types'
import { QcqDialogData, QcqDialogRow } from '@/types'
import { QcqOperations, SnackbarStateEnum } from '@/types/enums'
import QcqDialog from '@/components/QcqDialog.vue'
import { CompetencePayload } from '@/types/payload'
import DeleteDialog from '@/components/DeleteDialog.vue'

interface ComponentData {
  masterData: Array<Competence>
  isAddEnabled: boolean
  openDialog: boolean
  dialogTitle: string
  dialogData: QcqDialogData
  action: QcqOperations | undefined
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: string
  isSaveButtonDisabled: boolean
  isDeleteButtonDisabled: boolean
  showDeleteDialog: boolean
}

export default Vue.extend({
  name: 'QcqCompetencePage',

  components: {
    QcqDialog,
    QcqCommonGrid,
    DeleteDialog
  },

  data (): ComponentData {
    return {
      masterData: [],
      isAddEnabled: true,
      openDialog: false,
      dialogTitle: '',
      dialogData: { id: 0, code: '', language: 0, rows: [] },
      action: undefined,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      isSaveButtonDisabled: false,
      isDeleteButtonDisabled: false,
      showDeleteDialog: false
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },
  },

  methods: {
    onCloseDialog (): void {
      this.closeDialog()
    },

    closeDialog (): void {
      this.action = undefined
      this.openDialog = false
      this.showDeleteDialog = false
    },

    enableAddButtons (): void {
      this.isAddEnabled = true
    },

    onCompetenceClicked (rowId: number): void {
      // do nothing
    },

    onCompetenceDoubleClicked (rowId: number): void {
      this.showDialogCompetence(QcqOperations.EDIT, rowId)
    },

    showDialogCompetence (operation: number, currentSelectedRowId: number): void {
      this.$store.dispatch(LOAD_COMPETENCE_ROW, {
        currentSelectedRowId, operation
      }).then((dialogData: QcqDialogData) => {
        if (operation === QcqOperations.ADD) {
          this.dialogTitle = this.$t('qcqDialogComponent.addCompetence').toString()
        } else if (operation === QcqOperations.EDIT) {
          this.dialogTitle = this.$t('qcqDialogComponent.edit').toString()
        }
        this.dialogData = dialogData
        this.isSaveButtonDisabled = false
        this.isDeleteButtonDisabled = false
        this.action = operation
        if (operation === QcqOperations.ADD || operation === QcqOperations.EDIT) {
          this.openDialog = true
        } else if (operation === QcqOperations.REMOVE) {
          this.showDeleteDialog = true
        }
      })
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
      this.onSaveData()
    },

    async onSaveData (): Promise<void> {
      this.isSaveButtonDisabled = true
      this.isDeleteButtonDisabled = true
      const payload: CompetencePayload = {
        id: '',
        txtCode: this.dialogData.code,
        txtGer: this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'de') ? this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'de')!.description : '',
        txtFra: this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'fr') ? this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'fr')!.description : '',
        txtIta: this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'it') ? this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'it')!.description : '',
        txtEng: this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'en') ? this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'en')!.description : ''
      }
      if (this.dialogData.id !== null) {
        payload.id = this.dialogData.id.toString()
      }
      try {
        if (this.action === QcqOperations.ADD) {
          await this.$store.dispatch(INSERT_COMPETENCE, payload)
          this.messageSnackbar = this.$t('qcqQualificationPage.newCompetenceHasBeenAdded').toString()
        } else if (this.action === QcqOperations.EDIT) {
          await this.$store.dispatch(UPDATE_COMPETENCE, payload)
          this.messageSnackbar = this.$t('qcqQualificationPage.selectedDCompetenceHasBeenEdited').toString()
        } else if (this.action === QcqOperations.REMOVE) {
          await this.$store.dispatch(DELETE_COMPETENCE, payload)
          this.messageSnackbar = this.$t('qcqQualificationPage.selectedCompetenceHasBeenRemoved').toString()
        }
        this.closeDialog()
        this.loadCompetence()
        this.snackbarState = SnackbarStateEnum.Success
        this.showSnackbar = true
      } catch (e) {
        this.snackbarState = SnackbarStateEnum.Error
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
        this.showSnackbar = true
        this.isSaveButtonDisabled = false
        this.isDeleteButtonDisabled = false
      }
    },

    loadCompetence (): void {
      const COMPETENCE_ARG = 1
      this.$store.dispatch(LOAD_COMPETENCE, COMPETENCE_ARG)
        .then((data: Array<Competence>) => {
          this.masterData = data
        })
    }

  },

  created () {
    this.loadCompetence()
  }
})
